import useScrollAnimation from '../../../hooks/useScrollAnimation';
import { restaurantInfo } from '../../../mocks/restaurant';

const ContactSection = () => {
  const { ref: titleRef, animStyle: titleAnim } = useScrollAnimation();
  const { ref: contentRef, animStyle: contentAnim } = useScrollAnimation();

  return (
    <section id="contact" className="bg-teal-deep py-20 md:py-28 px-5 md:px-10">
      <div className="max-w-3xl mx-auto text-center">
        {/* Title */}
        <div ref={titleRef} style={titleAnim}>
          <p className="font-sans-jp text-xs tracking-[0.3em] text-teal-light mb-3 uppercase">
            Contact &amp; Reservation
          </p>
          <h2 className="font-serif-jp font-bold text-white text-2xl md:text-3xl tracking-wide mb-4">
            ご予約・お問い合わせ
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4 mb-10">
            <div className="h-px w-10 bg-white/30" />
            <div className="w-1.5 h-1.5 rounded-full bg-orange-sunset" />
            <div className="h-px w-10 bg-white/30" />
          </div>
        </div>

        {/* Content */}
        <div ref={contentRef} style={contentAnim} className="flex flex-col gap-8">
          {/* Phone Block */}
          <div className="bg-white/10 rounded-lg px-6 py-7 border border-white/20">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
              <i className="ri-phone-line text-2xl text-teal-light" />
            </div>
            <p className="font-sans-jp text-xs tracking-widest text-teal-light mb-2">お電話でのお問い合わせ</p>
            <a
              href={`tel:${restaurantInfo.phone}`}
              className="font-serif-jp text-white text-3xl md:text-4xl tracking-widest font-bold hover:text-teal-light transition-colors cursor-pointer"
            >
              {restaurantInfo.phone}
            </a>
            <p className="font-sans-jp text-xs text-white/60 mt-3 leading-loose">
              受付時間：11:00〜22:00（火曜定休）
            </p>
          </div>

          {/* External Links */}
          <div>
            <p className="font-sans-jp text-xs tracking-widest text-white/70 mb-5">
              外部予約・グルメサービス
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href={restaurantInfo.tabelogUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="font-sans-jp text-sm tracking-widest px-8 py-3 bg-orange-sunset text-white rounded-sm hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-external-link-line" />
                </div>
                食べログで問い合わせ
              </a>
              <a
                href={restaurantInfo.lineUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="font-sans-jp text-sm tracking-widest px-8 py-3 bg-white/15 text-white border border-white/30 rounded-sm hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-chat-smile-2-line" />
                </div>
                LINE公式アカウント
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="max-w-6xl mx-auto mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 flex items-center justify-center">
            <i className="ri-restaurant-line text-white/70 text-xl" />
          </div>
          <span className="font-serif-jp text-sm text-white/70 tracking-widest">
            ASIAN KITCHEN BALEN
          </span>
        </div>
        <p className="font-sans-jp text-xs text-white/40">
          © 2026 ASIAN KITCHEN BALEN. All Rights Reserved.
        </p>
      </div>
    </section>
  );
};

export default ContactSection;
